import { FC } from 'react';
import { AupEntry } from './AupEntry/AupEntry';

export const AupEntryPage: FC = () => {
  return <AupEntry />;
};
